













































































import Message from '@/types/Message.interface'
import Person from '@/types/Person.interface'
import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
import { popPreview } from '@/utility/helpers'
import Media from '@/types/Media.interface'
import Button from '@/types/components/Button.interface'
import UserLogo from '@/components/UserLogo.vue'
import SlidingAlert from '@/components/SlidingAlert.vue'
export default Vue.extend({
    components: { SlidingAlert, UserLogo },
    props: {
        fullWidth: {
            type: Boolean,
            default: false,
            required: false
        },
        message: {
            type: Object as PropType<Message>,
            required: true
        }
    },
    data: () => ({
        hovering: false
    }),
    computed: {
        ...mapGetters(['isApp', 'persons', 'users']),
        author(): Person {
            //  Get the author from the global store (we know it is loaded because inboxSelectedPerson is loaded)
            const author = this.persons.find(
                (x: Person) => x.id === this.message.author_id
            )

            //  Return the message author
            return author
        },
        containerId(): string {
            //  Grab our message id
            const id = this.message.id

            //  Construct a compound id
            return `message-inbound-${id}`
        },
        hoverButtons(): Button[] {
            //  Create our array of buttons
            return [
                {
                    icon: 'bi-quote',
                    color: 'white',
                    tooltip: 'Comment',
                    callback: () => this.$emit('comment')
                },
                {
                    icon: 'bi-front',
                    color: 'white',
                    tooltip: 'Copy to Clipboard',
                    hidden: !this.message.text,
                    callback: () => this.copyMessage()
                },
                {
                    icon: 'bi-trash-fill',
                    color: 'white',
                    tooltip: 'Delete Message',
                    disabledPopup: this.operator,
                    callback: () => this.deleteMessageConfirm()
                }
                // {
                //     icon: 'bi-circle-fill',
                //     color: 'primary',
                //     callback: () => console.log('MARK AS NEW')
                // },
                // {
                //     icon: 'bi-translate',
                //     color: 'white',
                //     callback: () => console.log('TRANSLATE')
                // }
            ]
        },
        hoverStyle(): object {
            //  Return the parsed styles
            return {
                display: 'flex',
                'align-items': 'center',
                'justify-content': 'center',
                position: 'absolute',
                top: '-40px',
                left: 0,
                height: '40px',
                width: '220px',
                'border-radius': '10px',
                filter: 'drop-shadow(0 -2px 2px #000)',
                'background-color': '#e0e0e0',
                'z-index': 1
            }
        },
        inboundImage(): string {
            return {
                QBO: this.$images.qboCircle,
                XERO: this.$images.xeroLogo,
                MESSAGEDESK: this.$images.brandMark,
                'system-clint': this.$images.clintHeadshot,
                'system-kyle': this.$images.kyleHeadshot,
                'system-josh': this.$images.joshHeadshot
            }[this.message.type]
        },
        inboundIcon(): string {
            return (
                {
                    invoiceCampaignTrigger: 'bi-hourglass-split',
                    forwarded: 'bi-telephone-inbound-fill'
                }[this.message.type] || 'mdi-account'
            )
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        parsedMessageText(): string {
            //  If message text does NOT exist, return nothing
            if (!this.message.text) return null

            //  Else, return parsed message
            const txt = this.$options.filters.parseMessageText(this.message.text, false)

            //  Return text
            return txt
        },
        validRoute(): boolean {
            //  Only return true if our path contains inbox OR teammates
            return (
                this.$route.path.includes('inbox') ||
                this.$route.path.includes('teammates')
            )
        }
    },
    methods: {
        copyMessage(): void {
            //  Create a temporary input to store our data
            const input = document.createElement('textarea')

            //  Add our input to the DOM
            document.body.appendChild(input)

            //  Get our parsed text
            const text = this.$options.filters.parseCommentedText(
                this.message.text,
                false
            )

            //  Set the value of this input to our message text
            input.value = text

            //  Focus our input
            input.focus()

            //  Select the text in our input (message text)
            input.select()

            //  Copy the text to clipboard
            document.execCommand('Copy')

            //  Remove our input now that we copied text
            input.remove()

            //  Notify our user with toast :)
            this.$store.commit('appNotificationBarSet', {
                message: 'Message Text Copied to Clipboard!',
                type: 'success'
            })
        },
        deleteMessageConfirm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Message',
                text: `Are you sure you'd like to delete this message? If yes, it will be removed from the conversation history`,
                icon: 'mdi-alert',
                color: 'primary',
                callback: (result: boolean) => this.deleteMessage(result)
            })
        },
        async deleteMessage(result: boolean): Promise<void> {
            //  If no result, do nothing
            if (!result) return

            // Else, delete the failed message
            const resp = await this.$store.dispatch('messagesDelete', this.message)
        },
        popPreview(media: Media): void {
            popPreview(media)
        }
    }
})
